/**
 * Session action creators that must not depend on the store.
 *
 * These are imported at module top level by the store setup and listener middleware,
 * so this module must not import `Store/index` (directly or transitively) to avoid circular imports.
 */
import { createAction } from '@reduxjs/toolkit';
import type { PubSub } from 'neuro-event-commons';
import { checkJWTNotExpired } from '../../utility/jwtAuthTools';

export const LOAD = 'neuro-ui/session/LOAD'; // Session (jwt) data actions
export const SUBSCRIBERS_CHANGED = 'neuro-ui/session/SUBSCRIBERS_CHANGED';
export const WEBSOCKET_CLOSED = 'neuro-ui/session/WEBSOCKET_CLOSED';

export const subscribersChangedAction = createAction(
  SUBSCRIBERS_CHANGED,
  (message: PubSub.ISubscriptionSummaryMessage) => ({
    payload: message,
  }),
);

export const websocketClosedAction = createAction(WEBSOCKET_CLOSED);

export const loadSessionAction = createAction(LOAD, (payload: IJWTBody | undefined) => {
  return {
    payload: !checkJWTNotExpired() ? { error: 'NAL - No auth on session load', data: payload } : { data: payload },
  };
});
